import { useState } from "react";
import PopUp from "../popup/PopUp";
import { Trash2 } from "lucide-react";

interface DeleteButtonProps {
  onConfirm: () => void;
}
const DeleteButton: React.FC<DeleteButtonProps> = ({ onConfirm }) => {
  const [showPopUp, setShowPopUp] = useState(false);

  const handleOnConfirm = () => {
    onConfirm();
    setShowPopUp(false);
  };

  return (
    <div>
      {showPopUp && (
        <PopUp
          onConfirm={handleOnConfirm}
          onClose={() => {
            setShowPopUp(false);
          }}
          message="Are you sure you want to delete this User ?"
        />
      )}

      <button
        onClick={() => setShowPopUp(true)}
        className="text-indigo-600 hover:text-red-600 mr-2 "
      >
        <Trash2 size={18} />
      </button>
    </div>
  );
};
export default DeleteButton;
